(ns frontend.view.nev.surveys.form.sub
    (:require
     [common.currencies :as currencies]
     [common.email :as email]
     [common.languages :as languages]
     [common.localization :as loc]
     [common.phone-util :as phone-util]
     [common.util :as cu]
     [frontend.logging :as logging]
     [frontend.state.current-session :as session]
     [re-frame.core :as rf]
     [ui.components.rich-text.view :as rich-text]
     [ui.editors.data-input :as data-input]))

(rf/reg-sub
  ::db
  (fn [{db :db} _]
    db))

(rf/reg-sub
  ::survey-profile
  (fn [db _]
    (get-in db [::survey-profile])))

(rf/reg-sub
  ::survey-process
  (fn [db _]
    (::survey-process db)))

(rf/reg-sub
  ::survey-id
  :<-
  [::survey-process]
  (fn [survey-process _]
    (:db/id survey-process)))

(rf/reg-sub
  ::previous-process
  (fn [db _]
    (get db ::previous-process)))

(rf/reg-sub
  ::previous-answers
  (fn [db _]
    (get db ::previous-answers)))

(rf/reg-sub
  ::survey-link
  :<-
  [::survey-process]
  (fn [process]
    (let [tenant @session/tenant]
      (str "https://"
           (:tenant/survey-domain tenant)
           "/survey?survey-token="
           (:survey-process/invite-token process)
           "&invitee-token="))))

(rf/reg-sub
  ::prefilled-changes
  (fn [db _]
    (get-in db [::prefilled-changes])))

(rf/reg-sub
  ::prefilled-state
  :<-
  [::survey-process]
  :<-
  [::prefilled-changes]
  (fn [[process changes] _]
    (merge process
           changes)))

(rf/reg-sub
  ::survey-templates
  (fn [db _]
    (let [templates (::survey-templates db)]
      templates)))

(rf/reg-sub
  ::survey-questions
  (fn [db _]
    (::survey-questions db)))

(rf/reg-sub
  ::unsaved-draft-changes
  :<-
  [::edit-answer-lookup]
  :<-
  [::survey-answers]
  :<-
  [::edit-no-answer-lookup]
  :<-
  [::survey-no-answer-descriptions]
  (fn [[edit-answers survey-answers edit-no-answers survey-no-answer-descriptions] _]
    (or (->> edit-answers
             (remove (fn [[id v]]
                       (= v (get survey-answers id))))
             (seq))
        (->> edit-no-answers
             (remove (fn [[id v]]
                       (= v (get survey-no-answer-descriptions id))))
             (seq)))))

(rf/reg-sub
  ::unsaved-wip-changes
  :<-
  [::edit-answer-lookup]
  :<-
  [::survey-answers]
  :<-
  [::edit-no-answer-lookup]
  :<-
  [::survey-no-answer-descriptions]
  (fn [[edit-answers survey-answers edit-no-answers survey-no-answer-descriptions] _]
    (or (->> edit-answers
             (remove (fn [[id v]]
                       (= v (get survey-answers id))))
             (seq))
        (->> edit-no-answers
             (remove (fn [[id v]]
                       (= v (get survey-no-answer-descriptions id))))
             (seq)))))

(rf/reg-sub
  ::unsaved-submitted-changes
  :<-
  [::edit-answer-lookup]
  :<-
  [::survey-answers]
  :<-
  [::edit-no-answer-lookup]
  :<-
  [::survey-no-answer-descriptions]
  (fn [[edit-answers survey-answers edit-no-answers survey-no-answer-descriptions] _]
    (or (->> edit-answers
             (remove (fn [[id v]]
                       (= v (get survey-answers id))))
             (seq))
        (->> edit-no-answers
             (remove (fn [[id v]]
                       (= v (get survey-no-answer-descriptions id))))
             (seq)))))

(rf/reg-sub
  ::unsaved-prefilled-changes
  :<-
  [::survey-process]
  :<-
  [::prefilled-changes]
  (fn [[process process-updates] _]
    (->> process-updates
         (remove (fn [[id v]]
                   (= v (get process id))))
         (seq))))

(rf/reg-sub
  ::valid-prefilled-data?
  :<-
  [::survey-process]
  :<-
  [::prefilled-changes]
  (fn [[process process-updates]]
    (->> process-updates
         (remove (fn [[id v]]
                   (= v (get process id))))
         (into {})
         :survey-process/invitees
         (remove (fn [invitee]
                   (or (when-let [email (:email invitee)]
                         (email/valid-email-pattern? email))
                       (when-let [phone (:phone invitee)]
                         (phone-util/valid-phone-number-str? phone)))))
         (empty?))))

(defn visibility-value
  [{:keys [edit-answer-lookup] :as props} rule]
  (let [res (case (:query-type rule)
              :query-type/and-collection
              (->> rule
                   :rules
                   (every? (partial visibility-value props)))
              :query-type/or-collection
              (->> rule
                   :rules
                   (some (partial visibility-value props)))
              :query-type/single-item
              (let [fld (:field rule)
                    fld-val (get edit-answer-lookup fld)]
                (case (:operator rule)
                  :operand/known (not (cu/blank-value? fld-val))
                  :operand/unknown (cu/blank-value? fld-val)
                  :operand/all-of (every? (if (coll? fld-val)
                                            (set fld-val)
                                            #{fld-val})
                                          (:value rule))
                  :operand/any-of (some (if (coll? fld-val)
                                          (set fld-val)
                                          #{fld-val})
                                        (:value rule))
                  (logging/unimplemented "Unknown visibility operator " rule))))]
    (js/console.log "VISIBILITY RULE : " (:query-type rule) " -> " (boolean res))
    res))

(defn calc-visibility
  [{:keys [item] :as props}]
  (case (:visibility item)
    nil true
    :visibility/always true
    :visibility/hidden false
    :visibility/conditional
    (->> item
         :visibility-rules
         (map (partial visibility-value props))
         (first)
         (boolean))))

(defn calc-mandatoriness
  [_props]
  ;; TODO: ? empty ?
  )

(defn resolve-value
  [{:keys [edit-answer-lookup] :as props} {:keys [calculi-type rules] :as rule}]
  (let [value (case calculi-type
                :calculi-type/operator-sum
                (let [sum-value (->> rules
                                     (map (partial resolve-value props))
                                     (remove nil?)
                                     (apply +))]
                  (if (->> rules
                           (map (partial resolve-value props))
                           (remove number?)
                           (not-empty))
                    js/NaN
                    sum-value))
                :calculi-type/operator-subtraction
                (let [subs-value (->> rules
                                      (map (partial resolve-value props))
                                      (remove nil?)
                                      (apply -))]
                  (if (->> rules
                           (map (partial resolve-value props))
                           (remove number?)
                           (not-empty))
                    js/NaN
                    subs-value))
                :calculi-type/operator-division
                (let [div-value (->> rules
                                     (map (partial resolve-value props))
                                     (remove nil?)
                                     (apply /))]
                  (if (->> rules
                           (map (partial resolve-value props))
                           (remove number?)
                           (not-empty))
                    js/NaN
                    div-value))
                :calculi-type/operator-multiplication
                (let [mult-value (->> rules
                                      (map (partial resolve-value props))
                                      (remove nil?)
                                      (apply *))]
                  (if (->> rules
                           (map (partial resolve-value props))
                           (remove number?)
                           (not-empty))
                    js/NaN
                    mult-value))
                :calculi-type/parenthesis-group
                (let [groupv-val (->> rules
                                      (map (partial resolve-value props))
                                      (first))]
                  groupv-val)
                :calculi-type/constant
                (:value rule)

                :calculi-type/field
                (let [fld (:field rule)
                      res (get edit-answer-lookup fld)]
                  res)
                (do (js/console.error "No calculi rule " rule)
                    nil))]
    ;(js/console.log "Calc value : " calculi-type " >> " value)
    value))

(defn resolve-calculated-value
  [props question]
  (->> question
       :survey-question/calculation-rules
       (map (partial resolve-value props))
       (first)))

(defn resolve-question-data
  [{:keys [lang question-lookup item edit-answer-lookup previous-answers no-answer-descriptions-lookup]
    :as   props}]
  (let [{:keys [survey-question-id visibility]} item
        question (get question-lookup survey-question-id)
        data-type (:survey-question/data-type question)
        question-label (get-in question [:survey-question/label-translations lang])
        previous-answer-exists? (contains? previous-answers survey-question-id)
        previous-value-raw (get previous-answers survey-question-id)
        options (if (= (:survey-question/data-type question)
                       :data.type/currency-symbol)
                  currencies/value-options
                  (->> question
                       :survey-question/options
                       (sort-by :common/ord)
                       (mapv (fn [o]
                               {:value (:db/id o)
                                :label (or (get-in o [:survey-question-option/label-translations lang])
                                           (->> o
                                                :survey-question-option/label-translations
                                                (first)
                                                (val)))}))))
        previous-value (when (and previous-answer-exists?
                                  (not (nil? previous-value-raw))
                                  (not (and (string? previous-value-raw)
                                            (cu/blank-value? previous-value-raw))))
                         (data-input/formatted-display-string
                           {:data-type   data-type
                            :value       previous-value-raw
                            :options     options
                            :lang        lang
                            :date-format (loc/tr :date-format)}))

        resolved-item (case (:survey-item-type item)
                        :survey-item/wysiwyg
                        (assoc item :rich-content (get-in item [:content lang]))
                        :survey-item/question
                        (merge question
                               item
                               {:options        options
                                :no-answer?     (get no-answer-descriptions-lookup survey-question-id)
                                :hidden?        (or (= visibility :visibility/hidden)
                                                    (and (= visibility :visibility/conditional)
                                                         false))
                                :data-unit      (:survey-question/data-unit question)
                                :data-type      (if (= :data.type/calculated-number data-type)
                                                  :data.type/number
                                                  data-type)
                                :calculated?    (= :data.type/calculated-number data-type)
                                :label          question-label
                                :value          (if (not= :data.type/calculated-number data-type)
                                                  (get edit-answer-lookup survey-question-id)
                                                  (let [calc-val (resolve-calculated-value props question)]
                                                    calc-val))
                                :previous-value (when (not= data-type :data.type/calculated-number)
                                                  previous-value)})
                        (logging/unimplemented "Unknown survey-item-type-" item))
        visible? (if (= :survey-item/wysiwyg (:survey-item-type item))
                   (calc-visibility props)
                   (and data-type
                        (calc-visibility props)))
        mandatory? (or (= :mandatory/always (:mandatoriness item))
                       (and visible?
                            (= :mandatory/when-visible (:mandatoriness item)))
                       (and (some #{(:mandatoriness item)} [:mandatory/conditional :mandatory/conditional-when-visible])
                            (calc-mandatoriness props)))]
    (js/console.log "Mandatory ? " item " >> " (= :mandatory/always (:mandatoriness item)))
    (assoc resolved-item
           :visible? visible?
           :mandatory? mandatory?
           :mandatoriness (:mandatoriness item))))

#_(defn resolve-block-info
    [{:keys [lang block focused-question-id]}]
    (or (->> block
             :content
             (keep (fn [item]
                     (when (and (not (cu/blank-value? focused-question-id))
                                (= focused-question-id
                                   (or (:survey-question-id item)
                                       (:id item)
                                       (:identifier item))))
                       (get-in item [:survey-question/info-translations lang]))))
             (first))
        (get-in block [:info lang])))

(defn resolve-block-info
  [{:keys [lang block question-lookup focused-question-id]}]
  (or (->> block
           :content
           (keep (fn [item]
                   (when (and (not (cu/blank-value? focused-question-id))
                              (= focused-question-id
                                 (or (:survey-question-id item)
                                     (:id item)
                                     (:identifier item))))
                     (let [template-question-info (get-in item [:survey-question/info-translations lang])
                           question (get question-lookup focused-question-id)
                           question-info (get-in question [:survey-question/info-translations lang])]
                       (or (when-not (rich-text/empty-editor-value? template-question-info)
                             template-question-info)
                           (when-not (rich-text/empty-editor-value? question-info)
                             question-info))))))
           (first))
      (get-in block [:info lang])))

(rf/reg-sub
  ::edit-mode?
  (fn [db]
    (get db ::edit-mode?)))

(rf/reg-sub
  ::survey-template-config
  :<-
  [::language]
  :<-
  [::survey-process]
  :<-
  [::survey-templates]
  :<-
  [::survey-answers]
  :<-
  [::edit-answer-lookup]
  :<-
  [::survey-no-answer-descriptions]
  :<-
  [::edit-no-answer-lookup]
  :<-
  [::survey-questions]
  :<-
  [::focused-question-id]
  :<-
  [::edit-mode?]
  :<-
  [::previous-answers]
  (fn [[lang process answer-lookup edit-answer-lookup no-answer-lookup edit-no-answer-lookup
        question-lookup focused-question-id edit-mode? previous-answers] _]

    (let [templates (->> process
                         :survey-process/burned-templates)
          main-template (->> templates
                             (cu/filter-by :db/id (:survey-process/template process))
                             (first))
          prefix-template (when-let [prefix-id (:survey-template/prefix-template main-template)]
                            (->> templates
                                 (cu/filter-by :db/id prefix-id)
                                 (first)))
          postfix-template (when-let [postfix-id (:survey-template/postfix-template main-template)]
                             (->> templates
                                  (cu/filter-by :db/id postfix-id)
                                  (first)))
          combined-answer-lookup (merge answer-lookup edit-answer-lookup)
          combined-no-answer-lookup (merge no-answer-lookup edit-no-answer-lookup)
          props {:lang                          lang
                 :question-lookup               question-lookup
                 :edit-answer-lookup            combined-answer-lookup
                 :no-answer-descriptions-lookup combined-no-answer-lookup
                 :focused-question-id           focused-question-id}
          read-only? (and (some #{:survey-process.status/approved :survey-process.status/approved-modified}
                                [(:survey-process/status process)])
                          (not edit-mode?))
          all-blocks (concat (:blocks (:survey-template/config prefix-template))
                             (:blocks (:survey-template/config main-template))
                             (:blocks (:survey-template/config postfix-template)))]
      (->> all-blocks
           (map-indexed
             (fn [block-index block]
               (case (:block-type block)
                 :survey-block/wysiwyg
                 (assoc block :wysiwyg-text (get-in block [:content lang]))
                 :survey-block/section
                 (-> block
                     (update-in [:label]
                                (fn [lbl]
                                  (get lbl lang)))
                     (assoc :status-strip-height 40)
                     (assoc :block-info
                            (resolve-block-info
                              (assoc props :block block)))
                     (assoc :read-only? read-only?)
                     (update-in [:content]
                                (fn [content]
                                  (->> content
                                       (map-indexed (fn [section-index item]
                                                      (resolve-question-data
                                                        (assoc props
                                                               :question-lookup question-lookup
                                                               :previous-answers previous-answers
                                                               :section-index section-index
                                                               :item item
                                                               :block-index block-index))))
                                       (filter :visible?)
                                       (vec)))))
                 (do (logging/unimplemented "Uknknown survey block " block)
                     block))))
           (vec)))))

(rf/reg-sub
  ::new-config
  :<-
  [::survey-process]
  (fn [survey-process _]
    (let [config (:survey-process/burned-survey-config survey-process)]
      (assoc config :db/id (:db/id survey-process)))))

(rf/reg-sub
  ::survey-answers
  (fn [db _]
    (get-in db [::survey-answers])))

(rf/reg-sub
  ::survey-no-answer-descriptions
  (fn [db _]
    (get-in db [::survey-no-answer-descriptions])))

(rf/reg-sub
  ::survey-no-answer-categories
  (fn [db _]
    (get-in db [::survey-no-answer-categories])))

(rf/reg-sub
  ::edit-answer-lookup
  (fn [db _]
    (get-in db [::edit-answer-lookup])))

(rf/reg-sub
  ::edit-no-answer-lookup
  (fn [db _]
    (get-in db [::edit-no-answer-lookup])))

(rf/reg-sub
  ::template-options
  (fn [db _]
    (let [opts (->> db
                    ::survey-templates
                    (map (fn [st]
                           {:value (:db/id st)
                            :label (:survey-template/label st)}))
                    (sort-by :label)
                    (vec))]
      opts)))

(rf/reg-sub
  ::language-options
  (fn [db _]
    (let [selected-template-id (get-in db [::survey-process :survey-process/template])
          all-templates (get-in db [::survey-templates])
          selected-template (->> all-templates
                                 (cu/filter-by :db/id selected-template-id)
                                 (first))
          lang-opts (if selected-template
                      (->> selected-template
                           :survey-template/languages
                           (map (fn [lang]
                                  {:value lang
                                   :label (languages/get-label lang)}))
                           (sort-by :label)
                           (vec))
                      (->> all-templates
                           (mapcat :survey-template/languages)
                           (distinct)
                           (map (fn [lang]
                                  {:value lang
                                   :label (languages/get-label lang)}))
                           (sort-by :label)
                           (vec)))]
      lang-opts)))

(rf/reg-sub
  ::valid-template-changes?
  :<-
  [::survey-process]
  :<-
  [::survey-templates]
  (fn [[process templates] _]
    (let [template-id (:survey-process/template process)
          template (->> templates
                        (cu/filter-by :db/id template-id)
                        (first))
          default-lang (:survey-process/language process)
          labels (:survey-process/localized-labels process)
          start-ts (:survey-process/timestamp-period-start process)
          end-ts (:survey-process/timestamp-period-end process)]
      (and template
           (some #{default-lang} (:survey-template/languages template))
           (pos? start-ts)
           (pos? end-ts)
           (every? (fn [lng]
                     (->> (get labels lng)
                          (cu/blank-value?)
                          (not)))
                   (:survey-template/languages template))))))

(rf/reg-sub
  ::selected-template
  :<-
  [::survey-process]
  :<-
  [::survey-templates]
  (fn [[process templates] _]
    (->> templates
         (filter (fn [t]
                   (= (:db/id t) (:survey-process/template process))))
         (first))))

(rf/reg-sub
  ::language
  :<-
  [::db]
  :<-
  [::language-options]
  (fn [[db language-options] _]
    (let [lang (or (get-in db [::language])
                   (get-in db [::survey-process :survey-process/language])
                   (->> language-options
                        (first)
                        :id))]
      (or lang
          :ENG))))

(rf/reg-sub
  ::focused-question-id
  (fn [db _]
    (get-in db [::focused-question-id])))
